import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { TransactionActionName } from '@frontend/transaction/types';
import React from 'react';

import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import useTransactionActionSelect from './transaction-action-select.controller';

const ID = 'transaction-action-select';
export interface TransactionActionSelectProps extends Omit<SelectInputV2Props<TransactionActionName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const TransactionActionSelect = (props: TransactionActionSelectProps) => {
    const viewProps = useTransactionActionSelect(props);

    return (
        <SelectInputV2<TransactionActionName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Transaction action'}
            options={viewProps.options}
        />
    );
};

export default TransactionActionSelect;
